/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import {Field} from "redux-form";
import {useI18N} from "../../my-puratos/hoc/withI18N";
import {Selector} from "../../my-puratos/molecules/wizard/Selector";
import {noValidation, required} from "../../../utils/my-puratos/FormUtils";
import {useDispatch} from "react-redux";
import {customFormStepFirst, customFormStepSecond} from "../../../actions/form";
import {getSpecificFormValue} from "../../components/ContactForm";

interface IProps {
    title: string,
    name: string,
    options: {id: string, value: string}[],
    disabled?: boolean,
    isRequired?: boolean,
    currentContactProfile?: string
}

export const OptionSelector: FunctionComponent<IProps> = ({title, name, options = [] , disabled = false, isRequired = true, currentContactProfile}) => {

    return <Field name={name} component={OptionInput} title={title} options={options} disabled={disabled}
                  validate={isRequired ? required : noValidation} required={isRequired} contactProfile={currentContactProfile}/>

}

const OptionInput = ({input, meta, title, options, disabled, required, contactProfile, checked, ...props}) => {
    const translate = useI18N();
    const dispatch = useDispatch();

    const sentChooseRoleAction = (roleID) => {
        if(input.name == "puratosFormToAddress"){
            dispatch(customFormStepFirst({
                occupation: getSpecificFormValue(options, roleID)
            }));
        } else if (input.name == "puratosContactReason"){
            dispatch(customFormStepSecond({
                contact_reason: getSpecificFormValue(options, roleID),
                occupation: contactProfile
            }));
        }
    }

    return (
        <React.Fragment>
            <h3>{translate(title)}</h3>
            <Selector name={input.name} {...input} {...props} isContactForm>
                {options.map(option =>
                    <Selector.Option sentChooseRoleAction={sentChooseRoleAction} key={option.id} value={option.id} disabled={disabled}>
                        <label>{translate(option.value)}</label>
                    </Selector.Option>)}
            </Selector>
        </React.Fragment>
    );

}
